export const defaultErrorMessage = 'Oops! Something went wrong. Please try again.';
export const accessDeniedErrorMessage = "Oops! You don't have access to perform this action";
// e.response.status

export const emptyFieldErrorMessage = 'Please fill in this field.';
